import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { totalBonuses, totalVolumes } from '../data/offer';
export function GuaranteeSection() {
  return <section className="bg-stage water-glow-soft py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-94" data-mp="9ttgc9z21wy4">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-95" data-mp="etpo8kavi8iy">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl border border-silverEdge bg-navyPanel p-8 shadow-card sm:p-12" data-id="element-96" data-mp="er35doij86lf">
          <span className="metal-surface inline-flex rounded-full p-4 text-navyDeep" data-id="element-97" data-mp="xjxj6f4f5so2">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-98" data-mp="xlrwb79g8ghl" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-extrabold text-white" data-id="element-99" data-mp="12gxj08aodz6q">
            Complete 7-day guarantee
          </h2>
          <p className="mt-4 leading-relaxed text-silver" data-id="element-100" data-mp="25sgifflb2a1e">
            Open all {totalVolumes} volumes. Review all {totalBonuses} bonuses. Use them in your most challenging
            meteorology class this week. If you feel your students didn't respond better or the materials didn't save
            you hours of work:
          </p>
          <p className="mt-6 rounded-lg border border-silver/40 bg-white/5 px-5 py-4 text-lg font-extrabold text-silverBright" data-id="element-101" data-mp="1rtqkxyukq8ci">
            We refund 100% of your money. No questions. No forms. No complications.
          </p>
          <p className="mt-5 text-sm leading-relaxed text-silverDark" data-id="element-102" data-mp="2jlo831ptsvgg">
            Because if this teacher ready doesn't deliver the value we promise, we don't want to keep your money.
          </p>
        </motion.div>
      </div>
    </section>;
}